<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <iframe style="border: none;" width="1100" height="550" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2Fprdzbn5WJhfGQtUEteu4Zd%2FGCS-Ads" allowfullscreen></iframe>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  export default {
    name: 'CreativePreview',
    components: {
    }
  }
</script>
<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
